import React, {  useState } from "react";
import AccountTickets from "./AccountTickets";
import AccountPasses from "./AccountPasses";
import { HiOutlineCreditCard, HiOutlineDocument, HiOutlineTicket } from "react-icons/hi";
import AccountDocuments from "./document";
import "./AccountDocPanel.scss";
import useDesktopSize from "../../../utils/hooks/useDesktopSize";
import { useSelector } from "react-redux";
import { State } from "../../store";
import LoadingSpinner from "../../../features/Loading/LoadingSpinner";
import { useTranslation } from "react-i18next";
import EAButton from "../shared/Buttons/EAButton";

const AccountDocPanel: React.FC = () => {
  const loading = useSelector((state: State) => state.auth.loading);
  const { t } = useTranslation();
  const [ticketsTabActive, setTicketsTabActive] = useState(0);
  const isDesktop = useDesktopSize();

  return (
    <div className="account-doc-panel">
      {loading ? (
        <div className="flex-between-center">
          <LoadingSpinner />
        </div>
      ) : (
        <div className="account-doc-title flex-between-center">
          <EAButton
            title={isDesktop ? t("twoje_bilety") : t("bilety")}
            onClick={() => setTicketsTabActive(0)}
            variant={ticketsTabActive === 0 ? "filled" : "text"}
            startIcon={<HiOutlineTicket />}
          />
          <EAButton
            title={isDesktop ? t("twoje_karnety") : t("karnety")}
            onClick={() => setTicketsTabActive(1)}
            variant={ticketsTabActive === 1 ? "filled" : "text"}
            startIcon={<HiOutlineCreditCard />}
          />
          <EAButton
            title={isDesktop ? t("twoje_dokumenty") : t("dokumenty")}
            onClick={() => setTicketsTabActive(2)}
            variant={ticketsTabActive === 2 ? "filled" : "text"}
            startIcon={<HiOutlineDocument />}
          />
        </div>
      )}

      <div className="account-doc-panel-content">
        {ticketsTabActive === 0 && <AccountTickets />}
        {ticketsTabActive === 1 && <AccountPasses />}
        {ticketsTabActive === 2 && <AccountDocuments />}
      </div>
    </div>
  );
};

export default AccountDocPanel;
